import React from 'react'

export default ({ name }) => {
  let firstName = name.split(' ')[0]

  return (
    <h3>
    Welcome, {firstName}
    </h3>
  )
}



// WEBPACK FOOTER //
// ./src/components/shared/welcome.jsx